import { Routes } from '@angular/router';
import { AuthenticationGuardService } from './auth/guards/authentication-guard';
import { HrGuardService } from './auth/guards/hr-guard';
import { LearnpathManagerComponent } from './modules/lms/learningpaths/components/learnpath-manager/learnpath-manager.component';
import { EmployeeTabsComponent } from './modules/personnel-files/employee-tabs/employee-tabs.component';
import { ClassicSandboxComponent } from './shared/iframe/components/classic-sandbox/classic-sandbox.component';

export const chrRoutes: Routes = [
  {
    path: 'chr',
    children: [
      {
        path: 'dashboard/worklists',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/dashboard/Newemployees.asp?indirrep=',
        },
      },
      {
        path: 'dashboard/recruitment',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/sharedmenus/mainpages/recruitment.asp?indirrep=',
        },
      },
      {
        path: 'dashboard/conversations',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/dashboard/home.asp?indirrep=0',
        },
      },
      {
        path: 'dashboard/organogram',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/organogram/positionsorganogram.asp?indirrep=',
        },
      },
      {
        path: 'dashboard/departmentorganogram',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/company/departmentsorganogram.asp?indirrep=',
        },
      },
      {
        path: 'dashboard/careermanagement',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/careermanagement/profileFilter.asp?indirrep=',
        },
      },
      {
        path: 'dashboard/coachings',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reviews/coachings.asp?indirrep=',
        },
      },
      {
        path: 'company',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/company/companylist.asp?indirrep=',
        },
      },
      {
        path: 'companydepartments',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/company/viewcompanydetaildepartments.asp?indirrep=',
        },
      },
      {
        path: 'companypositions',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/company/viewcompanydetailpositions.asp?indirrep=',
        },
      },
      {
        path: 'companyfunctions',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/company/viewcompanydetailfunctions.asp?indirrep=',
        },
      },
      {
        path: 'company/employees/search',
        component: EmployeeTabsComponent,
        data: {
          showLayout: true,
        },
      },
      {
        path: 'company/employees/reports',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/employeelookupreport.asp?indirrep=',
        },
      },
      {
        path: 'company/otsearch',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/positions/positionsearch.asp?indirrep=',
        },
      },
      {
        path: 'competences/accountabilities',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/accountabilities/viewaccountabilitiestree.asp?indirrep=',
        },
      },
      {
        path: 'conversations/planning',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reviews/viewreviewschedule.asp?indirrep=',
        },
      },
      {
        path: 'conversations/history',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reviews/viewperformancereviewhistory.asp?indirrep=',
        },
      },
      {
        path: 'conversations/templates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reviews/templates.asp?indirrep=',
        },
      },
      {
        path: 'recruitment/jobopenings',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/recruitment/viewjobopenings.asp?action=newdefault&indirrep=',
        },
      },
      {
        path: 'recruitment/candidates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/recruitment/candidatesearchresults.asp?indirrep=',
        },
      },
      {
        path: 'recruitment/tagcloud',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/recruitment/tagcloud.asp?indirrep=',
        },
      },
      {
        path: 'recruitment/suppliers',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/recruitmenttar/viewtar.asp?indirrep=',
        },
      },
      {
        path: 'recruitment/attachments',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/recruitment/viewattachments.asp?indirrep=',
        },
      },
      {
        path: 'recruitment/calendar',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/recruitment/viewjobopeningcalendar.asp?indirrep=',
        },
      },
      {
        path: 'certificates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/certificates/certificates.asp?indirrep=',
        },
      },
      {
        path: 'certificates/requirements',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/certificates/requirements.asp?indirrep=',
        },
      },
      {
        path: 'certificates/requirementkinds',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/certificates/requirementkind.asp?indirrep=',
        },
      },
      {
        path: 'certificates/certificateoverview',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/certificates/studentcertificates.asp?indirrep=',
        },
      },
      {
        path: 'lms/librarycatalog',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/library/librarylist.asp?expandcur=1&indirrep=',
        },
      },
      {
        path: 'lms/projectlist',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/projects/projectlist.asp?indirrep=',
        },
      },
      {
        path: 'lms/planning/catalog',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/courses/planning.asp?indirrep=',
        },
      },
      {
        path: 'lms/catalog',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/courses/courselist.asp?expandcur=1&indirrep=',
        },
      },
      {
        path: 'lms/planning/classroom',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/courses/calendar.asp?indirrep=',
        },
      },
      {
        path: 'lms/planning/trainercalendar',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/courses/trainercalendar.asp?indirrep=',
        },
      },

      {
        path: 'lms/courserequests',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/waitlist/waitlistsearch.asp?indirrep=',
        },
      },
      {
        path: 'lms/courseevent',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/courseevents/viewcourseeventdetailgeneral.asp',
        },
      },
      {
        path: 'lms/ncc',
        component: ClassicSandboxComponent,
        data: {
          showLayout: false,
          classicpath: '/perfnav/administration/en/common/waitlist/viewnewrequestdetail.asp',
        },
      },
      {
        path: 'lms/enrollments',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/waitlist/enrollsearch.asp?indirrep=',
        },
      },
      {
        path: 'lms/trainingvendors',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/trainingvendors/search.asp?indirrep=',
        },
      },
      {
        path: 'lms/locationequipment',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/facilityvendors/search.asp?indirrep=',
        },
      },
      {
        path: 'lms/trainers',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/trainers/search.asp?indirrep=',
        },
      },
      {
        path: 'lms/locationsearch',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/facilityvendors/locationsearch.asp?indirrep=',
        },
      },
      {
        path: 'lms/equipmentsearch',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/equipment/equipmentsearch.asp?indirrep=',
        },
      },
      {
        path: 'lms/assessments',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/assessments/assessmentslist.asp?indirrep=',
        },
      },
      {
        path: 'lms/evaluations',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/evaluations/evaluationslist.asp?indirrep=',
        },
      },
      {
        path: 'lms/evaluationtemplates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/evaluations/templatelist.asp?indirrep=',
        },
      },
      {
        path: 'talent/9box',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/EN/common/reviews/9boxview.asp?indirrep=',
        },
      },
      {
        path: 'talent/9boxconfiguration',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/EN/common/reviews/9boxconfiguration.asp?indirrep=',
        },
      },
      {
        path: 'reports/certificates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/certificatesreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/competencies',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/competenciesreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/adhocs',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/adhocreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/employeelookupreport',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/employeelookupreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/ftecomparison',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/ftecomparison.asp?indirrep=',
        },
      },
      {
        path: 'reports/training',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/trainingreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/cancelledtrainings',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/trainingCancelledreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/learningpaths',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/learnpathreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/trainingbudget',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/trainingreportbudget.asp?indirrep=',
        },
      },
      {
        path: 'reports/trainingassessments',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/trainingassessmentreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/socialbalance',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/socialbalance.asp?indirrep=',
        },
      },
      {
        path: 'reports/subsidy',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/subsidyreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/trainingemployees',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/mdwtrainingreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/futurecourseevents',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/futurecourseeventreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/objectives',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/objectivesreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/reviews',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/reviewsreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/overviewevaluations',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/reviewoverviewreport.asp?indirrep=',
        },
      },
      {
        path: 'reports/competencescores',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/reviewoverviewscorereport.asp?indirrep=',
        },
      },
      {
        path: 'reports/agecategories',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reports/agecategoryreport.asp?indirrep=',
        },
      },
      {
        path: 'setup/employeeadditionfields',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/udfieldsettings/udf.asp?indirrep=',
        },
      },
      {
        path: 'setup/certificates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/certificate/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/reviews',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/defaults/reviewsetup.asp?indirrep=',
        },
      },
      {
        path: 'setup/progresosettings',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/defaults/progresosettings.asp?indirrep=',
        },
      },
      {
        path: 'setup/intervalsettings',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/interval/intervalsettings.asp?indirrep=',
        },
      },
      {
        path: 'setup/administrators/chr',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/users/userlist.asp?indirrep=',
        },
      },
      {
        path: 'setup/administrators/lhr',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/localhr/localhrlist.asp?indirrep=',
        },
      },
      {
        path: 'setup/labels',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/labels/administrators/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/languages',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/languages/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/defaults',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/defaults/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/email',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/email/training',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catid=1&indirrep=',
        },
      },
      {
        path: 'setup/email/certificates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catid=9&indirrep=',
        },
      },
      {
        path: 'setup/email/reviews',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catid=2&indirrep=',
        },
      },
      {
        path: 'setup/email/reviews360',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catid=3&indirrep=',
        },
      },
      {
        path: 'setup/email/recruitment',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catid=4&indirrep=',
        },
      },
      /*   {
        path: 'setup/email/recruitment',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catid=2&indirrep=',
        },
      },*/
      {
        path: 'setup/email/extrafields',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catid=8&indirrep=',
        },
      },
      {
        path: 'setup/email/positionflow',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catID=10&indirrep=',
        },
      },
      {
        path: 'setup/email/adhoc',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catID=14&indirrep=',
        },
      },
      {
        path: 'setup/email/learningpaths',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catID=11&indirrep=',
        },
      },
      {
        path: 'setup/email/skills',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catID=15&indirrep=',
        },
      },
      {
        path: 'setup/email/presencepolicy',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/email/mailtemplatesetup.asp?catID=14&indirrep=',
        },
      },
      {
        path: 'setup/talentmanagement',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/talentmanagement/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/privacy',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/privacy/Privacysetup.asp?indirrep=',
        },
      },
      {
        path: 'setup/disclaimer',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/defaults/disclaimersetup.asp?indirrep=',
        },
      },
      {
        path: 'setup/manualdelete',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/privacy/manualdelete.asp?indirrep=',
        },
      },
      {
        path: 'setup/organograminfo',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/organogram/settingsorganograminfo.asp?indirrep=0',
        },
      },
      {
        path: 'setup/whoiswho',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/employee/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/accountabilities/levels',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=accountabilitylevels&indirrep=',
        },
      },
      {
        path: 'setup/picklists/accountabilities/actions',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=accountabilityactions&indirrep=',
        },
      },
      {
        path: 'setup/picklists/company/sector',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=companysector&indirrep=',
        },
      },
      {
        path: 'setup/picklists/company/type',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=companytype&indirrep=',
        },
      },
      {
        path: 'setup/picklists/company/countries',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=country&indirrep=',
        },
      },
      {
        path: 'setup/picklists/company/paymentterms',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=paymentterm&indirrep=',
        },
      },
      {
        path: 'setup/picklists/company/currency',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/currency/changecurrency.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/company/vat',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/vat/changevat.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/salary/jobclass',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/jobclass/changejobclass.asp?indirrep=',
        },
      },

      {
        path: 'setup/picklists/salary/gradesalary',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/jobcat/changejobcat.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/salary/salarycoefficient',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/salarycoefficients/changesalarycoefficient.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/salary/benefits',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/benefits/changebenefit.asp?indirrep=',
        },
      },

      {
        path: 'setup/picklists/salary/benefitsalaryvalues',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/benefitcategories/benefitcategories.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/objectivestatus',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=objectivestatus&indirrep=',
        },
      },
      {
        path: 'setup/picklists/coursecontenttype',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/contenttypes/changecontenttype.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/courselevel',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=courselevel&indirrep=',
        },
      },
      {
        path: 'setup/picklists/coursereason',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=coursereason&indirrep=',
        },
      },
      {
        path: 'setup/picklists/librarycontenttypes',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/librarycontenttypes/changecontenttype.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/libraryitemtypes',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/libraryitemtypes/changelibraryitemtype.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/locationtype',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/loctype/changeloctype.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/learningmethod',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/learnmethod/changelearnmethod.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/sessiontype',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/sessiontype/changesessiontype.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/courselanguage',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/courselanguage/changecourselanguage.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/courserejection',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/crrejectreason/changecrrejectreason.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/coursedecline',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/coursedeclinereason/changecoursedeclinereason.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/noshow',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/noshow/changenoshow.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/provcertificates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/provcert/changeprovcert.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/trainercertificates',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/traincert/changetraincert.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/busytime',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/trainbusytime/changetrainbusytime.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/fundings',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/fundings/changefunding.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/channels',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=recruitmentchannel&indirrep=',
        },
      },
      {
        path: 'setup/picklists/workregime',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=workregime&indirrep=',
        },
      },
      {
        path: 'setup/picklists/edudegrees',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=degree&indirrep=',
        },
      },
      {
        path: 'setup/picklists/edustudies',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=study&indirrep=',
        },
      },
      {
        path: 'setup/picklists/language',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=companylanguages&indirrep=',
        },
      },
      {
        path: 'setup/picklists/maritalstatus',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=maritalstatus&indirrep=',
        },
      },
      {
        path: 'setup/picklists/gender',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=gender&indirrep=',
        },
      },
      {
        path: 'setup/picklists/status',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=contactstatus&indirrep=',
        },
      },
      {
        path: 'setup/picklists/studentcategory',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=studentcategory&indirrep=',
        },
      },
      {
        path: 'setup/picklists/kind',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=studentkind&indirrep=',
        },
      },
      {
        path: 'setup/picklists/dismissalreason',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=dismissalreason&indirrep=',
        },
      },
      {
        path: 'setup/picklists/employeedoccategory',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=studentdoccats&indirrep=',
        },
      },
      {
        path: 'setup/picklists/groups',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/employeeteam/changeteam.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/areasofinterest',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/talentManagementAreasOfInterest/changeareaofinterest.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/motivationaldrivers',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/talentManagementMotivationalDriver/changemotivationaldriver.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/countries',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/talentmanagementcountries/changecountries.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/businesstrip',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/talentmanagementbusinesstrip/changebusinesstrip.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/coalitions',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/coalitions/changecoalition.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/brands',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/brands/changebrand.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/functionalareas',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/functareas/changefunctarea.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/hrmgrkind',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/hrmgr/changehrmgr.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/userdefinedpicklists',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/udpicklists/udpicklists.asp?indirrep=',
        },
      },
      {
        path: 'setup/picklists/agecategory',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/picklist.asp?plist=agecategory&indirrep=',
        },
      },
      {
        path: 'setup/lms/courserequests',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/training/setupcoursequestions.asp?indirrep=',
        },
      },
      {
        path: 'setup/lms/attendancelist',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/training/setupattendancelist.asp?indirrep=',
        },
      },
      {
        path: 'setup/lms/training',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/training/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/rs/careersite',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/recruitment/careersiterecruitmentsetup.asp?indirrep=',
        },
      },
      {
        path: 'setup/rs/recruitment',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/recruitment/setup.asp?indirrep=',
        },
      },
      {
        path: 'setup/rs/recruitmentworkflow',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/picklists/recruitmentworkflow/changecontenttype.asp?indirrep=',
        },
      },
      {
        path: 'setup/rs/careersitephotos',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/admin/recruitment/careersitesetup.asp?indirrep=',
        },
      },
      {
        path: 'setup/rs/externaljobsites',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/externalJobsites/adminjobsiteclient.asp?indirrep=',
        },
      },
      {
        path: 'setup/objectives/objectivesinmass',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/objectives/masterobjectives.asp?indirrep=',
        },
      },
      {
        path: 'activelist',
        component: ClassicSandboxComponent,
        data: {
          showLayout: false,
          classicpath: '/perfnav/administration/en/adm/activelist.asp',
        },
      },
      {
        path: 'competences/knowledge/domains',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/competencies/clusters.asp?indirrep=0',
        },
      },
      {
        path: 'competences/knowledge/categories',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/competencies/knowledgecategories.asp?indirrep=0',
        },
      },
      {
        path: 'competences/knowledge/manage',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/competencies/kennisdomeinen.asp?indirrep=0',
        },
      },
      {
        path: 'competences/knowledge/reporting',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/competencies/exportclusters.asp?indirrep=0',
        },
      },
      {
        path: 'competences/knowledge/mpcompetencies',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/mpcompetencies/compleft.asp?indirrep=',
        },
      },
      {
        path: 'conversations/visual',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/student/ML/common/teamreviews/teamgesprekken.asp?DOTNET=1',
        },
      },
      {
        path: 'conversations/emailconfiguration',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/common/reviews/emailsetup.asp?indirrep=',
        },
      },
      {
        path: 'dashboard/positionrequests',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/EN/sharedmenus/mainpages/positions.asp?indirrep=',
        },
      },
      {
        path: 'learningpathdashboard',
        component: LearnpathManagerComponent,
        data: {
          showLayout: true,
        },
      },
    ],
    canActivate: [AuthenticationGuardService, HrGuardService],
  },
];
